import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const FormCheckbox = ({ customKey, register, config, errors, hasMounted, isLoading = false }) => {
    return (
        <div key={customKey} className={`form-control flex flex-col ${config.classname}`}>
            <label
                className="label-text flex text-left cursor-pointer items-center"
                onChange={config.onChange ? config.onChange : () => {}}
            >
                {isLoading ? (
                    <div className="h-4 w-4 bg-gradient-to-r from-base-300 via-base-200 to-base-300 bg-[length:400%_100%] rounded mr-2 animate-[pulse_1s_ease-in-out_infinite_alternate]"></div>
                ) : (
                    <input
                        type="checkbox"
                        className={`checkbox disabled:bg-disabled disabled:text-disabled-content ${hasMounted ? "transition-all duration-300 ease-in-out" : ""}
                            ${errors ? "checkbox-error disabled:checkbox-error" : "checkbox-primary"}`}
                        data-tip={errors?.message}
                        disabled={config.disabled}
                        name={config.name}
                        id={config.name}
                        defaultChecked={config.defaultValue}
                        {...register(
                            config.name,
                            config.validators
                                ? config.validators
                                : {
                                      required: false,
                                      validate: false,
                                  },
                        )}
                    />
                )}
                <span className="px-2">{config.label}</span>{" "}
                {config.info && (
                    <div className="tooltip" data-tip={config.info}>
                        <FontAwesomeIcon icon={faCircleInfo} className="text-primary" />
                    </div>
                )}
            </label>
        </div>
    );
};

export default FormCheckbox;
